import { captureUtm, getUtm, utmPayload as baseUtmPayload, trackCta as baseTrackCta } from '../../lib/tracking';

const INTENT_KEY = 'corp_intent';

export { captureUtm, getUtm };

export const getIntent = () => sessionStorage.getItem(INTENT_KEY) || null;

/** Attribution + conversion-path intent for corp submissions. */
export const utmPayload = () => ({ ...baseUtmPayload('corp'), intent: getIntent() });

/** path: 'order' (I need custom wine) | 'partner' (Become a Lokal Partner). */
export const trackCta = (path, ctaId, setIntent = true) => {
  if (setIntent) sessionStorage.setItem(INTENT_KEY, path);
  baseTrackCta('corp', path, ctaId);
};
